/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import baseUrl from "../../BaseUrl";
import { Link } from 'react-router-dom';
import Modal from 'react-modal';

const Step2 = ({ onBack, onNext, cid, role,token, formData, setFormData }) => {
    const [popupOpen, setPopupOpen] = useState(false);
    const customer_id = formData.selectedCompany ?? '';

    // State for trunk assignment logic
    const [trunkList, setTrunkList] = useState([]);
    const [enhanceRouteSwitch, setEnhanceRouteSwitch] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedTrunk, setSelectedTrunk] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    // State for modal (advanced routing)
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [selectedPolicy, setSelectedPolicy] = useState('1'); // Default to top_down
    const [tableData, setTableData] = useState([
        { selectedOption: '', inputText: '', yesNo: '1' },
        { selectedOption: '', inputText: '', yesNo: '' },
        { selectedOption: '', inputText: '', yesNo: '' },
        { selectedOption: '', inputText: '', yesNo: '' },
        { selectedOption: '', inputText: '', yesNo: '' },
        { selectedOption: '', inputText: '', yesNo: '' },
        { selectedOption: '', inputText: '', yesNo: '' },
    ]);

    useEffect(() => {
        // Make the API call when the component mounts
        if (formData.selectedCompany) {
            getRoutingOption();
        }
    }, [customer_id, token]);

    useEffect(() => {
        if (showModal && currentItem) {
            const errors = validateFormData({ routePath: [{ [currentItem.tn_number]: { policy: selectedPolicy, tableData: tableData } }] });
            setValidationErrors(errors);
        }
    }, [showModal, currentItem, selectedPolicy, tableData]);

    const getRoutingOption = async () => {
        setPopupOpen(true);
        try {
            const compId = role <= 2 ? customer_id : cid;
            if (!compId) {
                setPopupOpen(false);
                return;
            }

            const response = await axios.get(`${baseUrl}/international-order-route-list/${compId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });

            const trunks = response.data.data;
            const isSwitchOn = response.data.switch === 1;

            setTrunkList(trunks);
            setEnhanceRouteSwitch(isSwitchOn);

            // Scenario 1: Automatic assignment if only one trunk is available
            if (trunks.length === 1) {
                const updatedReserveList = formData.reserveNumberList.map(num => ({
                    ...num,
                    policy: "1",
                    trunk_list: [{
                        customer_name: trunks[0].customer_name,
                        trunk_id: trunks[0].value
                    }],
                }));
                // Also create a default routePath for consistency
                const routePath = updatedReserveList.map(num => ({
                    [num.tn_number]: {
                        policy: "1",
                        tableData: [{
                            selectedOption: trunks[0].value,
                            inputText: '',
                            yesNo: '1'
                        }]
                    }
                }));

                setFormData(prev => ({ ...prev, reserveNumberList: updatedReserveList, routePath: routePath }));
            }
        } catch (error) {
            console.error(error);
        } finally {
            setPopupOpen(false);
        }
    };


    const handleNext = async (e) => {
        e.preventDefault();
        console.log(formData);
        const allNumbersAssigned = formData.reserveNumberList.every(num => {
            if (trunkList.length === 1) return true;
            if (enhanceRouteSwitch) {
                return formData.routePath?.some(p => p.hasOwnProperty(num.tn_number));
            } else {
                return num.trunk_list && num.trunk_list.length > 0;
            }
        });

        if (!allNumbersAssigned) {
            alert("Please assign a trunk to all telephone numbers before proceeding.");
            return;
        }
        onNext();
        
    };

    const handleRemoveSelected = (e, itemToRemove) => {
        e.preventDefault();
        const updatedList = formData.reserveNumberList.filter(item => item.tn_number !== itemToRemove.tn_number);
        const updatedRoutePath = formData.routePath?.filter(path => !path.hasOwnProperty(itemToRemove.tn_number));
        setFormData({ ...formData, reserveNumberList: updatedList, routePath: updatedRoutePath });
    };

    // --- Handlers for Simple Assignment (Switch OFF) ---
    const handleToggleSelect = (tn) => {
        const updatedSelection = selectedRows.includes(tn)
            ? selectedRows.filter(num => num !== tn)
            : [...selectedRows, tn];
        setSelectedRows(updatedSelection);
        setSelectAll(updatedSelection.length === formData.reserveNumberList.length);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(formData.reserveNumberList.map(item => item.tn_number));
        } else {
            setSelectedRows([]);
        }
        setSelectAll(e.target.checked);
    };

    const handleAssignTrunk = (e) => {
        e.preventDefault();
        if (!selectedTrunk) {
            alert("Please select a trunk to assign.");
            return;
        }
        if (selectedRows.length === 0) {
            alert("Please select at least one number.");
            return;
        }

        const selectedTrunkDetails = trunkList.find(t => t.value === selectedTrunk);

        const updatedReserveList = formData.reserveNumberList.map(num => {
            if (selectedRows.includes(num.tn_number)) {
                return {
                    ...num,
                    policy: "1",
                    trunk_list: [{
                        customer_name: selectedTrunkDetails.customer_name,
                        trunk_id: selectedTrunkDetails.value
                    }]
                };
            }
            return num;
        });

        setFormData(prev => ({ ...prev, reserveNumberList: updatedReserveList }));
        setSelectedRows([]);
        setSelectAll(false);
    };

    const validateFormData = (data) => {
        const errors = [];
        if (!data.routePath) {
            errors.push(`Please Fill proper trunk value for all number`);
        } else {
            data.routePath.forEach(dataItem => {
                const mobileKey = Object.keys(dataItem)[0];
                const currentMobile = dataItem[mobileKey];

                if (!currentMobile) {
                    errors.push(`Data for ${mobileKey} not found.`);
                } else {
                    if (!currentMobile.policy) {
                        errors.push(`Policy field is required for ${mobileKey}.`);
                    }

                    const hasTableDataValue = currentMobile.tableData.some(tableItem => tableItem.selectedOption);
                    const hasGap = currentMobile.tableData.some((tableItem, index) => {
                        if (index < currentMobile.tableData.length - 1) {
                            return tableItem.selectedOption === "" && currentMobile.tableData[index + 1].selectedOption !== "";
                        }
                        return false;
                    });

                    if (!hasTableDataValue) {
                        errors.push(`At least one route is required for ${mobileKey}.`);
                    } else if (hasGap) {
                        errors.push(`Please select routes sequentially without gaps for ${mobileKey}.`);
                    } else if (currentMobile.policy === "2") { // percentage
                        const filledRows = currentMobile.tableData.filter(row => row.selectedOption);
                        const inputTextValues = filledRows.map(tableItem => Number(tableItem.inputText) || 0);
                        const hasUserInput = inputTextValues.some(value => value > 0);

                        if (!hasUserInput) {
                            errors.push(`Percentage values for ${mobileKey} are required when policy is 'percentage'.`);
                        } else {
                            const sumOfInputTextValues = inputTextValues.reduce((acc, value) => acc + value, 0);
                            if (sumOfInputTextValues !== 100) {
                                errors.push(`Sum of percentage for ${mobileKey} must be 100.`);
                            }
                        }
                    }
                }
            });
        }
        return errors;
    };

    // --- Handlers for Advanced Assignment (Switch ON - Modal) ---
    const openModal = (item) => {
        setCurrentItem(item);
        const existingPath = formData.routePath?.find(p => p.hasOwnProperty(item.tn_number));
        if (existingPath) {
            setSelectedPolicy(existingPath[item.tn_number].policy);
            const savedTableData = existingPath[item.tn_number].tableData;
            const newTableData = [...savedTableData];
            const rowsToAdd = 7 - savedTableData.length;
            if (rowsToAdd > 0) {
                for (let i = 0; i < rowsToAdd; i++) {
                    newTableData.push({ selectedOption: '', inputText: '', yesNo: '' });
                }
            }
            setTableData(newTableData);
        } else {
            setSelectedPolicy('1');
            setTableData([
                { selectedOption: '', inputText: '', yesNo: '1' }, { selectedOption: '', inputText: '', yesNo: '' },
                { selectedOption: '', inputText: '', yesNo: '' }, { selectedOption: '', inputText: '', yesNo: '' },
                { selectedOption: '', inputText: '', yesNo: '' }, { selectedOption: '', inputText: '', yesNo: '' },
                { selectedOption: '', inputText: '', yesNo: '' }
            ]);
        }
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const handlePolicyChange = (event) => {
        setSelectedPolicy(event.target.value);
    };

    const handleRowChange = (e, index, fieldName) => {
        const newValue = e.target.value;
        setTableData(prevData => {
            const updatedData = [...prevData];
            updatedData[index] = { ...updatedData[index], [fieldName]: newValue };
            return updatedData;
        });
    };

    const handleSave = () => {
        const errors = validateFormData({ routePath: [{ [currentItem.tn_number]: { policy: selectedPolicy, tableData: tableData } }] });
        if (errors.length > 0) {
            setValidationErrors(errors);
            return;
        }

        const newPathData = {
            [currentItem.tn_number]: {
                policy: selectedPolicy,
                tableData: tableData.filter(row => row.selectedOption)
            }
        };

        const existingPathIndex = formData.routePath?.findIndex(p => p.hasOwnProperty(currentItem.tn_number)) ?? -1;
        let updatedRoutePath;
        if (existingPathIndex > -1) {
            updatedRoutePath = [...formData.routePath];
            updatedRoutePath[existingPathIndex] = newPathData;
        } else {
            updatedRoutePath = [...(formData.routePath || []), newPathData];
        }

        const updatedReserveList = formData.reserveNumberList.map(num => {
            if (num.tn_number === currentItem.tn_number) {
                return {
                    ...num,
                    policy: selectedPolicy,
                    trunk_list: tableData
                        .filter(row => row.selectedOption) // 1. Get only rows with a selected trunk
                        .map(row => {
                            console.log(row, "row");
                            // 2. Find the full trunk object to get its name
                            const trunkDetails = trunkList.find(trunk => trunk.value === row.selectedOption);
                            return {
                                ...row,
                                customer_name: trunkDetails ? trunkDetails.customer_name : '', // 3. Set customer_name
                                trunk_id: row.selectedOption // 4. Set trunk_id
                            };
                        })
                };
            }
            return num;
        });

        setFormData(prev => ({ ...prev, routePath: updatedRoutePath,  reserveNumberList: updatedReserveList }));
        closeModal();
    };

    const handleApplyToAll = () => {
        const confirmed = window.confirm("Are you sure you want to apply this configuration to all numbers in this order?");
        if (confirmed) {
            const currentConfig = {
                policy: selectedPolicy,
                tableData: tableData.filter(row => row.selectedOption)
            };

            const errors = validateFormData({ routePath: [{ 'temp': currentConfig }] });
            if (errors.length > 0) {
                setValidationErrors(errors.map(e => e.replace(' for temp', '')));
                return;
            }
            if (currentConfig.tableData.length === 0) {
                alert("Please configure at least one route before applying.");
                return;
            }

            const allPaths = formData.reserveNumberList.map(num => ({
                [num.tn_number]: currentConfig
            }));

            // const updatedReserveList = formData.reserveNumberList.map(num => ({
            //     ...num,
            //     policy: selectedPolicy,
            //     trunk_list: tableData.filter(row => row.selectedOption)
            // }));

            const updatedReserveList = formData.reserveNumberList.map(num => {
                
                    return {
                        ...num,
                        policy: selectedPolicy,
                        trunk_list: tableData
                            .filter(row => row.selectedOption) // 1. Get only rows with a selected trunk
                            .map(row => {
                                console.log(row, "row");
                                // 2. Find the full trunk object to get its name
                                const trunkDetails = trunkList.find(trunk => trunk.value === row.selectedOption);
                                return {
                                    ...row,
                                    customer_name: trunkDetails ? trunkDetails.customer_name : '', // 3. Set customer_name
                                    trunk_id: row.selectedOption // 4. Set trunk_id
                                };
                            })
                    };
                
                return num;
            });

            setFormData(prev => ({ ...prev, routePath: allPaths, reserveNumberList: updatedReserveList }));
            closeModal();
        }
    };

    const handleUnassignedSet = () => {
        const confirmed = window.confirm("Are you sure you want to apply this to all unassigned numbers?");
        if (confirmed) {
            const currentConfig = {
                policy: selectedPolicy,
                tableData: tableData.filter(row => row.selectedOption)
            };

            const errors = validateFormData({ routePath: [{ 'temp': currentConfig }] });
            if (errors.length > 0) {
                setValidationErrors(errors.map(e => e.replace(' for temp', '')));
                return;
            }
            if (currentConfig.tableData.length === 0) {
                alert("Please configure at least one route before applying.");
                return;
            }

            const assignedNumbers = new Set((formData.routePath || []).map(p => Object.keys(p)[0]));
            const unassignedNumbers = formData.reserveNumberList.filter(num => !assignedNumbers.has(num.tn_number));

            const newPaths = unassignedNumbers.map(num => ({
                [num.tn_number]: currentConfig
            }));
            // const updatedReserveList = formData.reserveNumberList.map(num => {
            //     // Apply config only if the number has no trunk_config yet
            //     if (!num.trunk_config || num.trunk_config.length === 0) {
            //         return {
            //             ...num,
            //             policy: selectedPolicy,
            //             trunk_list: tableData.filter(row => row.selectedOption)
            //         };
            //     }
            //     return num;
            // });

            const updatedReserveList = formData.reserveNumberList.map(num => {
                if (num.tn_number === currentItem.tn_number) {
                    return {
                        ...num,
                        policy: selectedPolicy,
                        trunk_list: tableData
                            .filter(row => row.selectedOption) // 1. Get only rows with a selected trunk
                            .map(row => {
                                console.log(row, "row");
                                // 2. Find the full trunk object to get its name
                                const trunkDetails = trunkList.find(trunk => trunk.value === row.selectedOption);
                                return {
                                    ...row,
                                    customer_name: trunkDetails ? trunkDetails.customer_name : '', // 3. Set customer_name
                                    trunk_id: row.selectedOption // 4. Set trunk_id
                                };
                            })
                    };
                }
                return num;
            });

            if (newPaths.length > 0) {
                setFormData(prev => ({
                    ...prev,
                    routePath: [...(prev.routePath || []), ...newPaths],
                    reserveNumberList: updatedReserveList
                }));
            }
            closeModal();
        }
    };

    const getTrunkDisplayForNumber = (item) => {
        if (trunkList.length === 1) {
            return item.trunk_list?.[0]?.customer_name || 'Auto-assigned';
        }
        if (enhanceRouteSwitch) {
            const path = formData.routePath?.find(p => p.hasOwnProperty(item.tn_number));
            if (path) {
                const trunkIds = path[item.tn_number].tableData.map(td => td.selectedOption);
                const trunkNames = trunkIds.map(id => trunkList.find(t => t.value === id)?.customer_name).join(', ');
                return trunkNames || 'Configured';
            }
            return 'Not Assigned';
        } else {
            return item.trunk_list?.[0]?.customer_name || 'Not Assigned';
        }
    };

    return(
   
    <>
        {popupOpen && (
            <div className='overlay'><div className="custom-loader"></div></div>
        ) }
        <div className="row">
            <div className="col-6">
                <div className="left-title">
                    <h1>International Number Order </h1>
                    <small>(Assign Trunks Step 2)</small>
                </div>
            </div>
            <div className="col-6">
            </div>
        </div>
        <div className="common-white-shadow-background setting-section tableinput-section">
            <div className="row footer-row">
                <div className="footer-row-left">
                    <a href="#" onClick={onBack} className="Back"> <img src={`${process.env.PUBLIC_URL}/images/back-arrow.png`} alt="Back" />Back</a>
                </div>
                <div className="footer-row-right">
                <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                    <a href="#" onClick={handleNext} className='next' >Next</a>
                </div>
            </div>
        </div>       
        <div className="common-white-shadow-background setting-section tableinput-section">
            <div className="row">
                <table className="tablebox new-number-two-setup">
                    <thead>
                        <tr>
                            <th>Country</th>
                            <th>Area Code</th>
                            <th>City</th>
                            <th>Tel Number</th> 
                            {trunkList.length > 1 && enhanceRouteSwitch && <th>Trunks</th> }
                            {trunkList.length > 1 && !enhanceRouteSwitch && (
                                <th>Select <input type="checkbox" onChange={handleSelectAll} checked={selectAll} /></th>
                            )}
                            
                                <th width="20%">
                                    Routing Option
                                    {trunkList.length > 1 && !enhanceRouteSwitch && (
                                        <>
                                    <select value={selectedTrunk} onChange={e => setSelectedTrunk(e.target.value)}>
                                        <option value="">Select</option>
                                        {trunkList.map(trunk => (
                                            <option key={trunk.id} value={trunk.value}>
                                                {trunk.customer_name}
                                            </option>
                                        ))}
                                    </select>
                                    <a className="search" onClick={e => handleAssignTrunk(e)} href="#">Assign</a>
                                    </>
                                )}
                                
                                </th>
                           
                            <th>Remove</th>                        
                        </tr>
                    </thead>
                    <tbody>
                    {formData.reserveNumberList.map((item, index) => 
                        <tr key={index}>
                            <td>{item.country}</td>
                            <td>{item.area_code}</td>
                            <td>{item.city}</td>
                            <td>{item.tn_number}</td>
                            {enhanceRouteSwitch && trunkList.length > 1 && <td>
                                
                                    <img src={`${process.env.PUBLIC_URL}/images/trunk-phone.png`} onClick={() => openModal(item)} style={{cursor: 'pointer'}} alt="Configure Trunks"/>
                            
                                
                            </td>}
                            {trunkList.length > 1 && !enhanceRouteSwitch && (
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedRows.includes(item.tn_number)}
                                        onChange={() => handleToggleSelect(item.tn_number)}
                                    />
                                </td>
                            )}
                            
                                <td><p className='green-text'>{getTrunkDisplayForNumber(item)}</p></td>
                            
                            {/* <td><p className='green-text'>{getTrunkDisplayForNumber(item)}</p></td> */}
                            <td>
                                <img src={`${process.env.PUBLIC_URL}/images/delete.png`} onClick={e => handleRemoveSelected(e, item)} alt="Remove" style={{cursor: 'pointer'}}/>
                            </td>
                        </tr>
                    )}
                        
                    </tbody>
                </table>
            </div>
        </div>

        <Modal isOpen={showModal} onRequestClose={closeModal} contentLabel="Trunk Assignment Modal">
            <div className='row'>
                <div className='col-sm-3 cancel-btn'><button onClick={closeModal}>Cancel</button></div>
                <div className='col-sm-9 apply-all'>
                    {formData.routePath?.length < formData.reserveNumberList.length &&
                        <button className="apply-btn" onClick={handleUnassignedSet}>Apply to Unassigned</button>
                    }
                    <button className="apply-btn" onClick={handleApplyToAll}>Apply to all</button>
                    <button className="save-btn" onClick={handleSave}>Apply to Number</button>
                </div>
            </div>
            <div className="policy">
                <label>Policy</label>
                <div className="switchbtn">
                    <select value={selectedPolicy} onChange={handlePolicyChange}>
                        <option value="1">top_down</option>
                        <option value="2">percentage</option>
                        <option value="3">round_robin</option>
                    </select>
                </div>
            </div>
            {validationErrors.map((error, index) => (
                <p style={{ color: "red" }} key={index}>{error}</p>
            ))}
            <div className='fullwidth-table track-table-body staff-listing-admin-table-body'>
                <table>
                    <thead>
                        <tr>
                            <th>Route</th>
                            {selectedPolicy === '2' && <th>Load Percentage</th>}
                            <th>Continuous routing</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <select value={row.selectedOption} onChange={(e) => handleRowChange(e, index, 'selectedOption')}>
                                        <option value="">Select Route</option>
                                        {trunkList.map(trunk => (
                                            <option key={trunk.id} value={trunk.value}>{trunk.customer_name}</option>
                                        ))}
                                    </select>
                                </td>
                                {selectedPolicy === '2' && (
                                    <td>
                                        <input type="number" value={row.inputText} onChange={(e) => handleRowChange(e, index, 'inputText')} /> %
                                    </td>
                                )}
                                <td>
                                    <select value={row.yesNo} onChange={(e) => handleRowChange(e, index, 'yesNo')}>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Modal>
    </>
)};

export default Step2;